import { ConfiguratorSlice, createConfiguratorSlice } from './slices/createConfiguratorSlice';
import { ContactInformationSlice, createContactInformationSlice } from './slices/createContactInformationSlice';
import { createTransportAndPaymentSlice, TransportAndPaymentSlice } from './slices/createTransportAndPaymentSlice';
import { createUserSlice, UserSlice } from './slices/createUserSlice';
import { createWishlistSlice, WishlistSlice } from './slices/createWishlistSlice';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type PersistStore = UserSlice & ContactInformationSlice & TransportAndPaymentSlice & ConfiguratorSlice & WishlistSlice;

export const usePersistStore = create<PersistStore>()(
    persist(
        (...store) => ({
            ...createUserSlice(...store),
            ...createContactInformationSlice(...store),
            ...createTransportAndPaymentSlice(...store),
            ...createConfiguratorSlice(...store),
            ...createWishlistSlice(...store),
        }),
        { name: 'app-store' },
    ),
);
